import envVariables from "src/lib/envVariables";
import { isAndroid, isIOS } from "src/lib/platform";

const PERSONIFY_SSO_START_PATH = "/v1/integrations/personify/sso/start";

/**
 * The backend's `/sso/start` is the only entry point into Personify's OIDC flow
 * (BACK-5919) — it redirects the member to Personify, then back through our own
 * `/sso/callback` with a single-use exchange token, so "continue" here means a
 * full browser navigation to our own API host, not Personify's.
 */
export const getContinueWithPersonifyTargetUrl = (): string => {
  const target = isIOS() ? "IOS" : isAndroid() ? "ANDROID" : "WEB";
  return `${envVariables.API_BASE_URL}${PERSONIFY_SSO_START_PATH}?target=${target}`;
};
